const requireComponent = require.context("./dislog", false, /\w+.(vue|js)$/);

const cmps = {};
//排除
const filterCmps = [];

requireComponent.keys().forEach((fileName) => {
  const cmp = requireComponent(fileName).default;
  !filterCmps.includes(fileName) && (cmps[cmp.name] = cmp);
});
import HisTable from "@/components/his";
import Laysuit from "./lawsuit/index"; //添加案件信息
import Count from "@/components/count";
import Beforetime from "./ndislog/beforetime"; //一审立案审查中
import Beforestart from "./ndislog/beforestart.vue";
import Police from "./ndislog/police.vue";
import Out from "@/components/out";
import Reason from "./ndislog/reason"; //作废原因
import InvalidTable from "./ndislog/invalidTable";
import Auction from "./auction";
import Share from "./btns/share"; //案件信息
import HisList from "./disList/HisList";
import CauseStepLog from "@/components/causeStepLog"; //操作记录
import OtherTypes from "./disList/Other/OtherTypes"; //被告其他信息
import OtherList from "./disList/Other"; //关联被告信息
import OtherModal from "./disList/Other/other.vue"; //关联被告信息
import CarList from "./disList/CarList"; //财产信息
import justice from "./testinfo/justice"; //测试修改
import execute from "./testinfo/execute"; //测试修改
import btns from "./btns/list"; //反馈记录
const components = [
  HisTable,
  Laysuit,
  Count,
  Beforetime,
  Beforestart,
  Police,
  Out,
  Reason,
  InvalidTable,
  Auction,
  Share,
  HisList,
  OtherList,
  CauseStepLog,
  CarList,
  OtherTypes,
  justice,
  execute,
  OtherModal,
  btns,
];
components.map((fileName) => {
  const cmp = fileName;
  !filterCmps.includes(fileName) && (cmps[cmp.name] = cmp);
});

export default cmps;
